import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Components
import PriceOptions from './common/PriceOptions';
  
const Pricing = () =>  {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
        
    useEffect(() => {
            
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
	  <div id="pricing" style={{padding: `${isMobile ? '1rem' : '3rem 1rem'}`, boxSizing: 'border-box', maxWidth: '64rem', marginLeft: 'auto', marginRight: 'auto'}}>
        {/* Section Header */}
        <div style={{textAlign: 'center', marginBottom: '2rem'}}>
            {/* Title - Header */}
            <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3rem'}`, fontWeight: 'bold', marginBottom: '1rem'}}>
                Pricing
            </h2>
            {/* Description - Header */}
            <p style={{fontSize: '1.125rem', lineHeight: '1.75rem', color: 'rgb(153,153,153)', fontWeight: 500}}>
                Ready to land your dream job?
            </p>
        </div>
        {/* Price Options */}
        <PriceOptions />
        <div style={{marginTop: '3rem', display: 'flex', justifyContent: 'center'}}>
            <Link to="/report-issues">
                <button className="yellow_hover" style={{background: 'rgb(0,0,0,.3)', color: 'rgb(156,156,156)', fontWeight: 600, fontSize: '.875rem', padding: '.5rem 1rem', borderRadius: '.75rem', height: '2.75rem', border: 'none', cursor: 'pointer'}}>
                    Issues paying with Stripe?
                </button>
            </Link>
        </div>
	  </div>
	);
  }
  
  export default Pricing;
  